import * as verovio from "verovio";
import * as Tone from "tone";
import { Midi } from "@tonejs/midi";
import JSZip from "jszip";
let toolkit;
export let currentMusicXML;
let currentMusicSVG;
let currentMusicMIDI;
let lastHighlightTime;
let playing = false;
let instrumentList;
let musicDisplay = document.querySelector("#musicDisplay");
let selectedListeningInstrument = 0;
let listeningMode = 0;
const synth = new Tone.PolySynth(Tone.Synth).toDestination();
export function initMusicXML(onLoad) {
    verovio.module.onRuntimeInitialized = () => {
        toolkit = new verovio.toolkit();
        toolkit.setOptions({ scale: 100, breaks: "none", svgBoundingBoxes: true });
        onLoad();
    };
}
function listInstrumentsFromXML(xmlString) {
    let parser = new DOMParser();
    let xmlDoc = parser.parseFromString(xmlString, "application/xml");
    let scoreParts = Array.from(xmlDoc.getElementsByTagName("part-name"));
    let names = scoreParts.map(sp => sp.textContent);
    return names;
}
//this function also updates the "select part" list because it was easier this way
function extractInstrumentFromMusicXML(xmlString, instrumentName) {
    let parser = new DOMParser();
    let xmlDoc = parser.parseFromString(xmlString, "application/xml");
    let scoreParts = Array.from(xmlDoc.getElementsByTagName("score-part"));
    scoreParts.forEach(sp => {
        console.log("wow " + sp.getElementsByTagName("part-name")[0]?.textContent);
    });
    let matchingIds = scoreParts.filter(sp => sp.getElementsByTagName("part-name")[0]?.textContent?.toLowerCase().includes(instrumentName.toLowerCase())).map(sp => sp.getAttribute("id"));
    if (matchingIds.length === 0) {
        console.log("Hey so big news bucko " + instrumentName + " isn't actually an instrument in the score");
    }
    let parts = Array.from(xmlDoc.getElementsByTagName("part"));
    parts.forEach(p => {
        if (!matchingIds.includes(p.getAttribute("id"))) {
            p.parentNode?.removeChild(p);
        }
    });
    let serializer = new XMLSerializer();
    return serializer.serializeToString(xmlDoc);
}
function highlightTime(time, scroll = false) {
    lastHighlightTime = time;
    let lastNotes = document.querySelectorAll(".notePlaying");
    for (let i = 0; i < lastNotes.length; i++) {
        lastNotes[i].classList.remove("notePlaying");
    }
    let elems = toolkit.getElementsAtTime(time * 1000 + 100);
    if (!elems) {
        if (scroll) {
            let win = document.querySelector("#musicDisplay");
            let svg = win.children[0];
            win.scrollTo({ left: svg.scrollWidth - win.clientWidth, top: win.scrollTop, behavior: "smooth" });
        }
        return;
    }
    let firstElem;
    for (let note of elems.notes) {
        let noteElement = document.getElementById(note);
        noteElement.classList.add("notePlaying");
        if (!firstElem || noteElement.getBoundingClientRect().left < firstElem.getBoundingClientRect().left) {
            firstElem = noteElement;
        }
    }
    if (scroll && firstElem) {
        let win = document.querySelector("#musicDisplay");
        let svg = win.children[0];
        win.scrollTo({ left: firstElem.getBoundingClientRect().x - svg.getBoundingClientRect().x - win.getBoundingClientRect().width / 2, top: win.scrollTop, behavior: "smooth" });
    }
}
let wasAll = true;
export function updateSheetInstrumentSelection() {
    let instrumentSelect = document.querySelector("#partSelector");
    let sheetSelects = document.querySelectorAll("#selectSheet input");
    if (sheetSelects[0].checked && !wasAll) {
        wasAll = true;
        updateMusicXML(currentMusicXML);
        highlightTime(lastHighlightTime, true);
    }
    else if (sheetSelects[1].checked) {
        wasAll = false;
        updateMusicXML(currentMusicXML, instrumentList[instrumentSelect.selectedIndex]);
        highlightTime(lastHighlightTime, true);
    }
}
export function updateMusicInstrumentSelection() {
    let instrumentSelect = document.querySelector("#partSelector");
    let musicSelects = document.querySelectorAll("#selectMusic input");
    if (!instrumentSelect || musicSelects[0].checked) {
        listeningMode = 0; //all
    }
    else if (musicSelects[1].checked) {
        listeningMode = 1;
        selectedListeningInstrument = instrumentSelect.selectedIndex;
    }
    else if (musicSelects[2].checked) {
        listeningMode = 2;
        selectedListeningInstrument = instrumentSelect.selectedIndex;
    }
}
export function shitFunction() {
    if (!playing) {
        Tone.getTransport().start();
        playing = true;
    }
    else {
        Tone.getTransport().pause();
        synth.releaseAll();
        playing = false;
    }
}
export function stopMusic() {
    Tone.getTransport().pause();
    playing = false;
}
function base64ToArrayBuffer(base64) {
    var binaryString = atob(base64);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}
//in seconds
export function getDuration() {
    return currentMusicMIDI ? currentMusicMIDI.duration : -1;
}
export function getTime() {
    return Tone.getTransport().seconds;
}
export function setTime(time) {
    Tone.getTransport().seconds = time;
    highlightTime(time, true);
}
//will uncompress zipped data or pass along uncompressed data
export function handleInputXML(input, ondone) {
    let prefix = new Int8Array(input, 0, 4);
    if (prefix[0] == 0x50 && prefix[1] == 0x4B && prefix[2] == 0x03 && prefix[3] == 0x04) { //zipped
        console.log("*unzips*");
        JSZip.loadAsync(input).then((value) => {
            console.log(value.files);
            value.file("META-INF/container.xml")?.async("string").then((str) => {
                console.log(str);
                let parser = new DOMParser();
                let xmlDoc = parser.parseFromString(str, "application/xml");
                let roots = Array.from(xmlDoc.getElementsByTagName("rootfile"));
                let mainPath = roots[0].attributes.getNamedItem("full-path")?.value;
                if (mainPath) {
                    value.file(mainPath)?.async("string").then((str2) => {
                        ondone(str2);
                    }, () => {
                        console.log("Invalid MXL file, container.xml does not point to main XML");
                    });
                }
            }, () => {
                console.log("Invalid MXL file, no container.xml");
            });
        });
    }
    else { //not zipped
        ondone(new TextDecoder("utf-8").decode(input));
    }
}
export function updateMusicXML(xml, instrument = "all") {
    currentMusicXML = xml;
    console.log("start");
    let strt = Date.now();
    if (instrument == "all") {
        toolkit.loadData(xml);
    }
    else {
        toolkit.loadData(extractInstrumentFromMusicXML(xml, instrument));
    }
    console.log(`loading data is done (${Date.now() - strt}ms)`);
    strt = Date.now();
    //at some point this has gotta be webworkered or something
    currentMusicSVG = toolkit.renderToSVG();
    console.log(`svg done (${Date.now() - strt}ms) with length` + currentMusicSVG.length);
    strt = Date.now();
    musicDisplay.innerHTML = currentMusicSVG;
    console.log("shit is on screen oh yeah " + (Date.now() - strt) + " ms");
    let svg = document.querySelector("#musicDisplay > svg");
    let aspect = svg.clientWidth / svg.clientHeight;
    svg.style.height = "min(35vw, 35vh)";
    svg.style.width = "calc(min(35vw, 35vh) * " + aspect + ")";
    let notes = document.querySelectorAll(".note:not(.bounding-box)");
    for (let i = 0; i < notes.length; i++) {
        let note = notes[i];
        note.onclick = () => {
            let mtime = toolkit.getMIDIValuesForElement(note.id).time * 0.001;
            //TODO somehow ive gotta make it so all choreo pieces set temporarilyMoved to false here
            highlightTime(mtime);
            // onTimeChange(mtime);
            //console.log(Tone.getTransport().seconds);
            Tone.getTransport().seconds = mtime;
        };
    }
}
export function loadMusicXML(url, onDone) {
    let req = new XMLHttpRequest();
    req.open("GET", url, true);
    req.responseType = "arraybuffer";
    req.onreadystatechange = () => {
        if (req.readyState == 4 && req.status == 200) {
            // let blob = req.response;
            let response = req.response;
            handleInputXML(response, (xml) => {
                instrumentList = listInstrumentsFromXML(xml);
                let selectorThing = document.querySelector("#partSelector");
                if (selectorThing) {
                    instrumentList.forEach(inst => {
                        let n = document.createElement("option");
                        n.value = inst.toLowerCase();
                        n.textContent = inst;
                        selectorThing.appendChild(n);
                    });
                }
                updateMusicXML(xml);
                let midi = toolkit.renderToMIDI();
                currentMusicMIDI = new Midi(base64ToArrayBuffer(midi));
                let events = currentMusicMIDI.tracks.flatMap(track => track.notes.map(note => ({
                    time: note.time,
                    note: note.name,
                    duration: note.duration,
                    velocity: note.velocity,
                    voice: track.name
                })));
                const part = new Tone.Part((time, value) => {
                    if (listeningMode == 0) {
                        synth.triggerAttackRelease(value.note, value.duration, time, value.velocity);
                    }
                    else if (listeningMode == 1) { //emphasized
                        synth.triggerAttackRelease(value.note, value.duration, time, value.voice == instrumentList[selectedListeningInstrument] ? 1.0 : value.velocity * 0.5);
                    }
                    else if (value.voice == instrumentList[selectedListeningInstrument]) {
                        synth.triggerAttackRelease(value.note, value.duration, time, value.velocity);
                    }
                    highlightTime(value.time, true);
                    // onTimeChange(value.time);
                }, events).start(0);
                onDone();
            });
        }
    };
    req.send();
}
